import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ContextProvider } from "context/context";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import localstorageService from "services/local-storage";
import httpService from "services/https";
import validationService from "services/validation";

import store from "redux/index";
import "./index.css";

global.services = {
  http: httpService,
  localstorage: localstorageService,
  validation: validationService,
};

ReactDOM.render(
  <React.StrictMode>
    <ContextProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </ContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
